import { getLocale, type Locale } from './t.ts'

/** `Intl` 에 넘기는 값. 숫자는 두 쪽 다 `1,021` 꼴이라 표 폭이 흔들리지 않는다 */
const INTL_LOCALE: Record<Locale, string> = { ko: 'ko-KR', en: 'en-US' }

/** 화면 표기용 `Intl` 로케일 — `value.toLocaleString(intlLocale())`. 파싱용 고정값(`en-CA` · `en-US`)에는 쓰지 않는다 */
export function intlLocale(): string {
  return INTL_LOCALE[getLocale()]
}

/** 포맷터를 언어마다 한 벌만 짓는다. 모듈 최상위 상수로 두면 부팅의 `setLocale` 보다 먼저 굳을 수 있어 부를 때 고른다 */
function perLocale<F>(build: (locale: string) => F): () => F {
  const built = new Map<string, F>()
  return () => {
    const locale = intlLocale()
    let found = built.get(locale)
    if (found === undefined) {
      found = build(locale)
      built.set(locale, found)
    }
    return found
  }
}

export function localeDateTimeFormat(
  options: Intl.DateTimeFormatOptions,
): () => Intl.DateTimeFormat {
  return perLocale((locale) => new Intl.DateTimeFormat(locale, options))
}

export function localeNumberFormat(options: Intl.NumberFormatOptions): () => Intl.NumberFormat {
  return perLocale((locale) => new Intl.NumberFormat(locale, options))
}
